import React, { FC, useEffect } from "react";
import "./style.scss";
import { ErrorMessage, Field } from "formik";

type PropsType = {
  customClass?: "large" | "reg";
  maxLength: number;
  placeholder: string;
  id: string;
  label: string;
  autoFocus?: boolean;
  isInvalid?: boolean;
  errorMessage?: string;
  setFieldValue: (field: string, value: string) => void;
  touched?: boolean;
  value: any;
  inputRef?: React.MutableRefObject<any>;
};

const DateInput: FC<PropsType> = ({
  customClass = "reg",
  maxLength,
  placeholder,
  id,
  label,
  autoFocus,
  isInvalid,
  setFieldValue,
  touched,
  value,
  inputRef,
}) => {
  // const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
  //   const newValue = e.target.value;
  //   if (!isNaN(+newValue)) {
  //     if (newValue.length <= maxLength) {
  //       setFieldValue(id, newValue);
  //     }
  //   }
  // };

  // const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
  //   let newValue = e.target.value;

  //   if (newValue === "" || !isNaN(+newValue)) {
  //     if (id !== "year" && newValue.length === 1 && /^[0-9]$/.test(newValue)) {
  //       newValue = newValue.padStart(2, "0");
  //     }
  //     if (newValue.length <= maxLength) {
  //       setFieldValue(id, newValue);
  //     }
  //   }
  // };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = e.target.value;

    // if (newValue.length === 1 && newValue === "0") {
    //   if (value.length === 0) {
    //     return;
    //   }
    // }

    if (!isNaN(+newValue)) {
      if (newValue.length <= maxLength) {
        setFieldValue(id, newValue);
      }
    }
  };

  const handleBlur = (e: React.FocusEvent<HTMLInputElement>) => {

    const val = e.target.value;
    if (id !== "year" && val.length === 1) {
      setFieldValue(id, val.padStart(2, "0"));
    } else if (id === "year" && val.length > 0 && val.length < 4) {
      setFieldValue(id, val.padEnd(4, "0"));
    }
  };

  return (
    <div className="dateBox">
      <label htmlFor={id}>{label}</label>
      <Field
        type={"tel"}
        inputMode="numeric"
        pattern="[0-9]*"
        name={id}
        id={id}
        className={`dateInput ${customClass} ${
          touched ? (isInvalid ? "input-error" : "input-success") : ""
        }`}
        placeholder={placeholder}
        autoFocus={autoFocus}
        autoComplete="off"
        onChange={handleChange}
        onBlur={handleBlur}
        value={value}
        innerRef={inputRef}
      />
      <ErrorMessage
        name={id}
        component="span"
        className={
          customClass === "large"
            ? "date-error-large date-error-message"
            : "date-error-message"
        }
      />
    </div>
  );
};

export default DateInput;
